import { render, staticRenderFns } from "./PlatformStatementDetail.vue?vue&type=template&id=4d83217a&"
import script from "./PlatformStatementDetail.vue?vue&type=script&lang=js&"
export * from "./PlatformStatementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports